module.exports = __webpack_public_path__ + "img/archi-daniel.f4f5b8ae.jpg";